export default __webpack_public_path__ + "9e412c150189776073cf9e7ca4c471b3.png";